import { Stream } from "@cloudflare/stream-react";

const VIDEO_ID = "23d8ea4f7b5b5a8e72b2e1fa34ed1eeb";
const POSTER_URL =
  `https://customer-n5ekme97isdmfb28.cloudflarestream.com/${VIDEO_ID}/thumbnails/thumbnail.jpg?time=5s&width=1280&height=720&fit=clip`;

export default function BuryMeInAychieh() {
  return (
    <section className="live-funeral" aria-labelledby="bury-me-in-aychieh-title">
      <div className="live-funeral__heading">
        <span className="live-funeral__cross" aria-hidden="true">✝</span>
        <p className="live-funeral__kicker">Aychieh · Lebanon</p>
        <h1 id="bury-me-in-aychieh-title">Bury Me in Aychieh</h1>
        <p className="live-funeral__title-arabic" lang="ar" dir="rtl">ادفنوني بالعيشية</p>
      </div>

      <div className="live-funeral__introduction">
        <p>
          “Bury Me in Aychieh” was composed by Father Paul Oneid in response to
          repeated family discussions about where he wished to be laid to rest.
          Through this deeply personal poem, he expressed his firm and unmistakable
          desire to return to Aychieh—the village of his birth, faith, priestly
          service, and lifelong devotion. His words were not merely a preference,
          but a heartfelt affirmation that Aychieh was his spiritual and earthly
          home, and the only place where he wished to rest.
        </p>
      </div>

      <section className="live-funeral__recording" aria-labelledby="bury-me-in-aychieh-video-title">
        <div className="live-funeral__section-heading">
          <p className="live-funeral__section-label">Recorded in Arabic</p>
          <h2 id="bury-me-in-aychieh-video-title" lang="ar" dir="rtl">ادفنوني بالعيشية</h2>
        </div>

        <div className="live-funeral__player">
          <Stream
            controls
            src={VIDEO_ID}
            poster={POSTER_URL}
            responsive
            preload="metadata"
            autoplay={false}
            muted={false}
            primaryColor="#7d3f75"
            letterboxColor="#2e1c29"
            title="ادفنوني بالعيشية — Bury Me in Aychieh"
          />
        </div>
      </section>

      <div className="live-funeral__guidance">
        <h2>Watching the video</h2>
        <ul>
          <li>Press the play button and turn on your sound.</li>
          <li>The recording is presented in Arabic.</li>
          <li>A stable Wi-Fi or wired internet connection is recommended.</li>
        </ul>
      </div>
    </section>
  );
}
